export default __webpack_public_path__ + "static/media/aboutUs2Medium.1d3143b8.webp";